import { CircularProgress, styled } from '@mui/material';
import React from 'react';

const CenteredLoading = styled(CircularProgress)`
  position: absolute;
  top: 50%;
  left: 50%;
`;

const LoadingWrapper = styled('div')<{ $shadeBackground: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: ${(props) =>
    props.$shadeBackground ? 'rgba(0, 0, 0, 0.1)' : 'transparent'};
  /* z-index: 1000; */
`;

interface LoadingProps {
  color?: 'primary' | 'secondary';
  shadeBackground?: boolean;
}

export const LoadingOverlay = (props: LoadingProps) => {
  const { color, shadeBackground = true } = props;
  return (
    <LoadingWrapper $shadeBackground={shadeBackground}>
      <CenteredLoading data-cy="panalyt-loader" color={color ?? 'primary'} />
    </LoadingWrapper>
  );
};
